import { getBanners } from "../../../services/Api";
import { useEffect, useState } from "react";
import { getImageBanners } from "../../ultils";
const Sidebar = () => {
  const [banners, setBanners] = useState([]);
  useEffect(() => {
    getBanners({
      params: {
        limit: 6,
        sort: 1,
      },
    })
      .then(({ data }) => {
        // console.log(data.data.docs);
        setBanners(data.data.docs);
      })
      .catch((error) => console.log(error));
  }, []);

  return (
    <div id="sidebar" className="col-lg-4 col-md-12 col-sm-12">
      <div id="banner">
        {banners?.map((banner, index) =>
          banner.publish ? (
            <div key={index} className="banner-item">
              <a href={banner.url}>
                <img
                  className="img-fluid"
                  src={getImageBanners(banner.image)}
                />
              </a>
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};
export default Sidebar;
